import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './sic-video-iframe.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

export type VideoRatio = 'single' | 'gallery' | 'single_4x3';

/**
 * The SIC VideoIframe component
 *
 * @element sic-video-iframe
 * @slot default slot iframe
 * @prop {String}: video-ratio (single, gallery)
 *
 * Lightdom styles in sic-video-iframe.lightdom.css included in /shared.css
 */
@customElement('sic-video-iframe')
export class SicVideoIframe extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, attribute: 'video-ratio' })
  videoRatio: VideoRatio = 'single';

  render(): TemplateResult {
    return html`
      <div class="video-wrapper video-ratio--${this.videoRatio}">
        <slot></slot>
      </div>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'sic-video-iframe': SicVideoIframe;
  }
}
